export { Delay as default } from './Delay'
